{
  "toasts": {
    "error": {
      "addUser": "Användaren lades inte till, något gick fel",
      "adoptionDateNotSet": "Kunde inte sätta beslutsdatum",
      "avatar": "Kunde inte spara bilden",
      "categoryNotCreated": "Kategorin skapades inte, något gick fel",
      "categoryNotRemoved": "Kategorin kunde inte tas bort",
      "copyFailed": "Kunde inte kopiera länken",
      "diffSummaryFailed": "Misslyckades att generera ändringssammanfattning",
      "documentDownloaded": "Fel vid nedladdning av dokument",
      "projectNotArchived": "Kunde inte arkivera projekt",
      "editUser": "Användaren ändrades inte, något gick fel",
      "email": "E-postmeddelandet hittades inte",
      "generic": "Ett oväntat fel inträffade, vänligen försök att ladda om sidan",
      "incorectCurrentPass": "Felaktigt lösenord",
      "incorectPass": "Du har angett en felaktig e-postadress eller lösenord",
      "invalid2faCode": "Ogiltig verifieringskod. Vänligen försök igen.",
      "passNotReset": "Fel vid återställning av lösenord",
      "reorder": "Fel vid ordning av kategorier",
      "reorderDocuments": "Misslyckades med att ändra ordningen på dokumenten",
      "save": "Spara fel",
      "tierNotCreated": "Nivån skapades inte, något gick fel",
      "tierNotRemoved": "Nivån kunde inte tas bort",
      "workflowNotMoved": "Kunde inte flytta arbetsflöde",
      "workflowNotCancelled": "Kunde inte avbryta arbetsflöde"
    },
    "success": {
      "2faActivated": "Tvåfaktorsautentisering är aktiverad.",
      "2faDisabled": "Tvåfaktorsautentisering är inaktiverad.",
      "adoptionDateSet": "Beslutsdatum har satts",
      "categoryCreated": "Kategorin skapades",
      "categoryRemoved": "Kategorin har tagits bort",
      "categoryUpdated": "Kategorin har uppdaterats",
      "projectArchived": "Projekt arkiverat",
      "documentDownloaded": "Dokumentet har laddats ned",
      "documentUpdated": "Dokumentet har uppdaterats",
      "keyCopied": "Nyckeln har kopierats",
      "linkCopied": "Länk kopierad till urklipp",
      "passUpdated": "Ditt lösenord har uppdaterats",
      "photoSaved": "Fotot har sparats",
      "profileUpdated": "Profilen har uppdaterats",
      "readersInvited": "Inbjudningar till läsare har skickats",
      "reorder": "ordnades framgångsrikt",
      "tagCreated": "\"{{tagName}}\" skapad och vald",
      "tierCreated": "Nivån skapades framgångsrikt",
      "tierRemoved": "Nivån har tagits bort",
      "tierUpdated": "Nivån har uppdaterats",
      "workflowCancelled": "Arbetsflöde avbrutet"
    },
    "warning": {
      "maxSize": "Maximal bildstorlek är 1 MB"
    },
    "info": {
      "cookieBanner": "Vi använder en cookie för att hjälpa oss att förstå hur användare interagerar med applikationen.",
      "cookieHeader": "Cookieinställningar",
      "noDiffSummaryAvailable": "Inga skillnader hittades mellan versionerna. Gör ändringar i dokumentet och försök igen.",
      "noDocumentsFound": "Inga dokument hittades för de valda filtren",
      "sessionExpired": "Sessionen har löpt ut, vänligen logga in igen"
    }
  }
}
